import React from 'react';

import type { UniquePaymentId } from '../../../../generated-types';
import { OutboxStatus } from '../EditOutboxModal/types';
import UnapproveError from './UnapproveError';
import UnapproveSuccess from './UnapproveSuccess';
import UnapproveView from './UnapproveView';

type UnapproveItemFlowProps = {
    status: OutboxStatus | undefined;
    onUnapprove: () => void;
    onClose: () => void;
    outboxItemId: UniquePaymentId;
    confirmUnapproveState: [boolean, () => void];
};

const ListItemUnapproveFlow: React.FC<UnapproveItemFlowProps> = ({
    status,
    onUnapprove,
    onClose,
    confirmUnapproveState,
    outboxItemId,
}) => {
    switch (status) {
        case 'error':
            return <UnapproveError onRetry={onUnapprove} onClose={onClose} />;
        case 'success':
            return <UnapproveSuccess />;
        default:
            return (
                <UnapproveView
                    outboxItemId={outboxItemId}
                    confirmUnapproveState={confirmUnapproveState}
                    onUnapprove={onUnapprove}
                    showSpinner={status === 'pending'}
                />
            );
    }
};

export default ListItemUnapproveFlow;
